import { Table, Box, Grid, TableHead, TableCell, TableRow, TableContainer, TableBody, TableSortLabel, Autocomplete, Typography, Button, IconButton, CircularProgress, TextField, Pagination } from '@mui/material';
import { Input } from "antd";
import { useState, useEffect } from 'react';
import SpinnerLoader from '../../components/general/SpinnerLoader';
import VacationService from '../../../services/vacation';
import GeneralService from '../../../services/general';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // Icono opcional
import { Toast } from '../../../utils/alerts';
import { CODES } from '../../../utils/responseCodes';
import ApprovedBallotsModal from '../../components/Vacaciones/ApprovedBallotsModal';

const columns = [
    { id: '#', label: '#', minWidth: 20, },
    { id: 'nombre', label: 'Nombre', minWidth: 100, align: 'center' },
    { id: 'n_papeleta', label: 'n° papeleta', minWidth: 60, align: 'center', },
    { id: 'fecha_salida', label: 'Fecha de Salida', minWidth: 80, align: 'center', type: 'icon' },
    { id: 'fecha_reincorporacion', label: 'Fecha de reincorporación', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'n_diasTomados', label: 'Total de dias tomados', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'fecha_registro', label: 'Fecha de registro', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'fecha_aprobacion', label: 'Fecha de aprobación', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'acciones', label: 'Acciones', minWidth: 120, align: 'center' }
];
const filtros = [
    { label: 'Fecha de salida', value: 'fecha_salida' },
    { label: 'Fecha de reincorporación', value: 'fecha_reincorporacion' },
    { label: 'Fecha de registro', value: 'fecha_registro' },
    { label: 'Fecha de aprobación', value: 'fecha_aprobacion' }
];
const inputStyle = (disabled = false) => ({
    fontSize: 'medium',
    paddingTop: '0.5rem',
    color: "rgba(0, 0, 0, 0.65)",
    backgroundColor: disabled ? "#EBEAEAFF" : "#ffffff",
});

export default function VacationList({ userToken }) {
    // estados:
    const [empresas, setEmpresas] = useState([]); //Aqui llegan todas las empresas
    const [infoCompany, setInfoCompany] = useState(null); //Aqui se guarda la empresa que selecciona el usuario
    const [clientes, setClientes] = useState([]); //Aquí llegan todos los clientes de la empresa seleccionada
    const [infoClient, setInfoClient] = useState(null); //Aqui se guarda el cliente que selecciona el usuario
    const [Papeletas, setPapeletas] = useState([]);
    // para saber si ya se hizo la primera busqueda o no
    const [hasSearched, setHasSearched] = useState(false);
    // es spiner por si lo necesitamos: (si hasta ahora no lo usamos, borralo)
    const [titleModalLoader, setTitleModalLoader] = useState('');
    const [openModalLoader, setOpenModalLoader] = useState(false);
    // el gift de carga
    const [loading, setLoading] = useState(false);
    // para la gestion del paginador
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // para la gestion del filtro de fecha:
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filtroFecha, setFiltroFecha] = useState('fecha_salida');
    // para la gestion del filtro por persona
    const [personas, setPersonas] = useState([]);
    const [personaSeleccionada, setPersonaSeleccionada] = useState(null);
    // para el modal de papeletas por persona:
    const [modalOpen, setModalOpen] = useState(false);
    const [modalPapeletas, setModalPapeletas] = useState([]);
    const [personaNombre, setPersonaNombre] = useState('');
    // para el ordenamiento alfabetico, númerico y de fechas A5
    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    useEffect(() => {
        getAllCompanies();
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        setStartDate(firstDay.toISOString().split('T')[0]);
        setEndDate(lastDay.toISOString().split('T')[0]);
    }, []);

    const getAllCompanies = async () => {
        try {
            const result = await GeneralService.getEmpresas();
            if (result.status === CODES.SUCCESS_200) {
                if (result.data.length === 0)
                    Toast.fire({
                        icon: 'error',
                        title: 'No se encontro ninguna empresa'
                    });
                setEmpresas(result.data);
            }
        } catch (error) {
            console.log(`Error en getAllCompanies: ${error}`);
        }
    }

    const handleChangeEmpresa = async (event, newValue) => {
        setInfoCompany(newValue);
        if (newValue) {
            try {
                const response = await GeneralService.getClientesByEmpresa(newValue.id_empresa);
                setClientes(response.data);
                setInfoClient(null)
            } catch (error) {
                console.error("Error obteniendo clientes:", error);
                setClientes([]);
                setInfoClient(null)
            }
        } else {
            setInfoCompany(null);
            setClientes([]);
            setInfoClient(null);
            setCurrentPage(1);
            setPersonaSeleccionada(null);
            setPersonas([]);
            setPapeletas([]);
        }
    };

    const handleChangeCliente = (event, newValue) => {
        setInfoClient(newValue);
        setCurrentPage(1);
        setPersonaSeleccionada(null);
        setPersonas([]);
        setPapeletas([]);
    };

    const buscarPapeletas = async (page = 1, nombreParam = null) => {
        const nombreFinal = nombreParam !== null ? nombreParam : (personaSeleccionada ?? '');
        if (!infoClient || !infoCompany) {
            Toast.fire({
                icon: 'warning',
                title: 'Primero debe seleccionar una empresa y un cliente'
            });
            return;
        }
        setLoading(true);
        setHasSearched(true);
        try {
            const response = await VacationService.GetApprovedBallotsByClient(
                infoClient.id_cliente,
                filtroFecha,
                startDate,
                endDate,
                page,
                nombreFinal
            );
            setPapeletas(response.data.papeletas.data);
            setTotalPages(response.data.papeletas.last_page);
            setCurrentPage(page);
            // Cargamos el array completo de personas (sin paginar)
            setPersonas(response.data.personas.map(nombre => ({ nombre })));
        } catch (error) {
            console.error("Error cargando papeletas:", error);
            setPapeletas([]);
            setTotalPages(1);
            setPersonas([]);
        } finally {
            setLoading(false);
        }
    };

    const download_papeleta = async (papeletaID) => {
        try {
            setOpenModalLoader(true);
            const response = await VacationService.downloadBallotByid(papeletaID);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            // Abre el PDF en una nueva pestaña
            window.open(url, '_blank');
            // El fragmento comentado aqui crea un enlace oculto para descargar el PDF:
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', `papeleta-${papeletaID}.pdf`);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // Liberar el objeto URL
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        } catch (error) {
            console.error('Error al abrir o descargar la papeleta:', error);
        } finally {
            setOpenModalLoader(false);
        }
    };

    const previewConsolidatedBallots = async () => {
        const ids = Papeletas.map(p => p.id_papeleta);
        if (ids.length === 0) {
            Toast.fire({
                icon: 'warning',
                title: 'No hay papeletas para descargar.'
            });
            return;
        }
        try {
            setOpenModalLoader(true);
            setTitleModalLoader('Esto llevará un minuto; no cierres la pestaña.')
            const response = await VacationService.massiveDownloadByIds(ids);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            // El fragmento comentado aqui crea un enlace oculto para descargar el PDF:
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', 'ConsolidadoDePapeletas.pdf');
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        } catch (error) {
            console.error("Error al descargar el PDF consolidado:", error);
        } finally {
            setOpenModalLoader(false);
            setTitleModalLoader('');
        }
    };

    const handleNombreClick = async (row) => {
        try {
            setOpenModalLoader(true);
            const response = await VacationService.GetAproveBallotsByPersona(row.persona_id);
            setModalPapeletas(response.data);
            setPersonaNombre(row.nombre);
            setModalOpen(true);
        } catch (error) {
            console.error('Error al obtener papeletas aprobadas:', error);
        } finally {
            setOpenModalLoader(false);
        }
    };

    //A5 funciones para el ordenamiento por front: (handleSort y getSortedPapeletas)
    const handleSort = (columnId) => {
        if (columnId === 'acciones' || columnId === '#') return; // No ordenar estas
        if (sortBy === columnId) {
            setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortBy(columnId);
            setSortDirection('asc');
        }
    };
    const getSortedPapeletas = () => {
        if (!sortBy) return Papeletas;

        const sorted = [...Papeletas].sort((a, b) => {
            let valA = a[sortBy];
            let valB = b[sortBy];

            // Convertir fechas si es una fecha
            if (['fecha_salida', 'fecha_reincorporacion', 'fecha_registro', 'fecha_aprobacion'].includes(sortBy)) {
                valA = new Date(valA);
                valB = new Date(valB);
            }

            // Convertir a número si es un campo numérico
            if (sortBy === 'n_diasTomados') {
                valA = Number(valA);
                valB = Number(valB);
            }

            if (valA < valB) return sortDirection === 'asc' ? -1 : 1;
            if (valA > valB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });

        return sorted;
    };

    return (
        <>
            <ApprovedBallotsModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                papeletas={modalPapeletas}
                personaNombre={personaNombre}
                funcionDescargar={download_papeleta}
            />
            <Box display="flex" flexDirection="column" alignItems="center" width="100%">
                <Grid container direction="row" justifyContent="center" alignItems="center" p={1} spacing={{ xs: 1, sm: 2, md: 2 }}>
                    <Grid item xs={11} sm={6} md={2.5}>
                        <Autocomplete
                            size="small"
                            renderInput={(params) => <TextField {...params} label="Empresa" />}
                            options={empresas}
                            value={infoCompany ?? null}
                            onChange={(event, newValue) => handleChangeEmpresa(event, newValue)}
                            // isOptionEqualToValue={(option, value) => option.value === value.value}
                            getOptionLabel={(option) =>
                                option && typeof option === 'object' ? option.desEmpresa ?? '' : ''
                            }
                        />
                    </Grid>
                    <Grid item xs={11} sm={6} md={2.5}>
                        <Autocomplete
                            size="small"
                            renderInput={(params) => <TextField {...params} label="Cliente" />}
                            options={clientes}
                            value={infoClient}
                            onChange={handleChangeCliente}
                            getOptionLabel={(option) => {
                                if (!option || typeof option !== 'object') return '';
                                return `${option.id_cliente ?? ''} - ${option.desCliente ?? ''}`;
                            }}
                            // isOptionEqualToValue={(option, value) => option.id_cliente === value.id_cliente}
                        />
                    </Grid>
                </Grid>

                <Box width={{ xs: '90%', md: '90%' }} mt={{ xs: 4, md: 5 }} mb={{ xs: 2, md: 3 }}>
                    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={2.5} md={2.5} style={{ marginTop: '0.5rem' }}>
                            <legend style={{ fontSize: 'medium' }}>Filtrar por:</legend>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={filtros}
                                value={filtros.find(f => f.value === filtroFecha)}
                                onChange={(e, newValue) => setFiltroFecha(newValue?.value || 'fecha_salida')}
                                renderInput={(params) => (
                                    <TextField {...params} sx={{ backgroundColor: 'white' }} />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} style={{ marginTop: '0.5rem' }}>
                            {/* <fieldset> */}
                            <legend style={{ fontSize: 'medium' }}>Desde:</legend>
                            <Input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                style={inputStyle()}
                            />
                            {/* </fieldset> */}
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} style={{ marginTop: '0.5rem' }}>
                            <fieldset>
                                <legend style={{ fontSize: 'medium' }}>Hasta:</legend>
                                <Input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={inputStyle()}
                                />
                            </fieldset>
                        </Grid>
                        <Grid item xs={12} sm={1} md={1} style={{ marginTop: '2rem' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => buscarPapeletas()}
                                fullWidth
                            >
                                Buscar
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={3.5} md={3.5} style={{ marginTop: '2rem' }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={personas}
                                value={personaSeleccionada ? { nombre: personaSeleccionada } : null}
                                onChange={(event, newValue) => {
                                    const nombre = newValue ? newValue.nombre : '';
                                    setPersonaSeleccionada(nombre);
                                    buscarPapeletas(1, nombre);
                                }}
                                getOptionLabel={(option) => option.nombre || ''}
                                isOptionEqualToValue={(option, value) => option.nombre === value.nombre} // Comparar los objetos por nombre
                                renderInput={(params) => <TextField {...params} label="Buscar por persona" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={1} md={1} style={{ marginTop: '2rem' }}>
                            <IconButton
                                title='Descargar todas las papeletas'
                                color="info"
                                onClick={previewConsolidatedBallots}
                                // size="small"
                                style={{ border: 'solid 0.02rem', borderRadius: 0 }}
                            >
                                <PictureAsPdfIcon fontSize="inherit" />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <CircularProgress />
                    </Box>
                ) : !infoCompany || !infoClient || (Papeletas.length === 0 && hasSearched === false) ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <Typography variant="body1" color="textSecondary">
                            Seleccione una empresa, un cliente y presione buscar.
                        </Typography>
                    </Box>
                ) : hasSearched && Papeletas.length === 0 ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <Typography variant="body1" color="textSecondary">
                            No se encontraron papeletas.
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth, cursor: column.id !== 'acciones' && column.id !== '#' ? 'pointer' : 'default' }}
                                                onClick={() => handleSort(column.id)}
                                            >
                                                {column.id !== 'acciones' && column.id !== '#' ? (
                                                    <TableSortLabel
                                                        active={sortBy === column.id}
                                                        direction={sortBy === column.id ? sortDirection : 'asc'}
                                                    >
                                                        {column.label}
                                                    </TableSortLabel>
                                                ) : (
                                                    column.label
                                                )}
                                            </TableCell>
                                            // A5 antes era asi:
                                            // <TableCell
                                            //     key={column.id}
                                            //     align={column.align}
                                            //     style={{ minWidth: column.minWidth }}
                                            // >
                                            //     {column.label}
                                            // </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {getSortedPapeletas().map((row, index) => ( //A5 antes era asi: {Papeletas.map((row, index) => (
                                        <TableRow key={`row-${index}`}>
                                            {columns.map((col) => (
                                                <TableCell key={col.id} align={col.align || 'left'}>
                                                    {col.id === '#' ? (
                                                        index + 1 + (currentPage - 1) * 7
                                                    ) : col.id === 'nombre' ? (
                                                        <span
                                                            onClick={() => handleNombreClick(row)}
                                                            style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                                                        >
                                                            {row[col.id]}
                                                        </span>
                                                    ) : col.id === 'acciones' ? (
                                                        <IconButton
                                                            title='Ver papeleta'
                                                            size="small"
                                                            color='info'
                                                            style={{ border: 'solid 0.02rem', borderRadius: 0 }}
                                                            onClick={() => download_papeleta(row.id_papeleta, `papeleta-${row.n_papeleta}`)}
                                                        >
                                                            <PictureAsPdfTwoToneIcon fontSize="inherit" />
                                                        </IconButton>
                                                    ) : (
                                                        row[col.id]
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={(event, value) => buscarPapeletas(value)}
                            color="primary"
                            sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
                        />
                    </>
                )}

                <SpinnerLoader open={openModalLoader} title={titleModalLoader} />
            </Box>
        </>
    )
}